import React , { useState, useEffect, useRef } from 'react';
import jwt_decode from 'jwt-decode';
import budgetsection from '../images/common/budget.png';
import adminsection from '../images/common/settings.png';
import menu from '../images/common/menu.png';
import icon from '../images/common/icon.png';
import help from '../images/common/help-blue.png';
import account from '../images/common/account.png';

import img_menu_arrows from '../images/common/arrows.png';
import img_menu_administration from '../images/admin/user.svg';
import img_menu_agency from '../images/admin/agencies.svg';
import img_menu_agencyfees from '../images/admin/agencyFees.svg';
import img_menu_exchangerates from '../images/admin/exchange.svg';
import img_menu_geography from '../images/admin/geography.svg';
import img_menu_maisons from '../images/admin/maison.svg';
import img_menu_mediareferences from '../images/admin/media.svg';

import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../css/Admin.css';
import { Router, Switch, Route } from "react-router-dom";
import history from "../Components/history";

import SignUp from '../Components/SignupComponent';
import AdminHome from "../Components/admin_components/AdminHome";
import App from "../Components/admin_components/GridSample";
import AgencyFees from "../Components/admin_components/AgencyFees";
import UserAdministration from "../Components/admin_components/UserAdministration";
import Agencies from "../Components/admin_components/Agencies";
import Zone from "../Components/admin_components/Zone";
import Subzone from "../Components/admin_components/Subzones";
import Country from "../Components/admin_components/Countries";
import Maisons from "../Components/admin_components/Maisons";
import ExchangeRates from "../Components/admin_components/ExchangeRates";
import Role from "../Components/admin_components/Roles";
import Profile from "../Components/admin_components/Profiles";
import AgencyNetwork from '../Components/admin_components/AgencyNetwork';
import Publishersvendors from '../Components/admin_components/PublishersVendors';
import Airports from '../Components/admin_components/Airports';
import Vehicles from '../Components/admin_components/Vehicles';
import Positions from '../Components/admin_components/Positions';
import Insertitionpoc from '../Components/admin_components/InsertionPOC';
import PlanPage  from '../Components/admin_components/pages/Plan';
import TrialPage from '../Components/admin_components/pages/TrialPage';
import '../css/Buttons.css';
import MenuPopup from '../Components/admin_components/pages/customComponents/MenuPopup';
import checkSessionStatus from '../utils/checkSessionStatus';

const appName = "";///ArchicubedWeb //Production
const LoadAgencyFees = (section) =>{
    history.push(appName+ '/admin' + (section != '' ? '/'+section : '')) ;
}

const LoadSection = (section) =>{
    history.push(appName + (section != '' ? '/'+section : '')) ;
}

function AdminPage() {
    
    const [show,setShow] = useState(false);

    const decoded = jwt_decode(localStorage.getItem('token'));
    //console.log(decoded.can_manage_agency_fees);
    
    const [showAgency,setShowAgency] = useState(decoded.can_manage_agency == "true");
    const [showAgencyFees,setShowAgencyFees] = useState(decoded.can_manage_agency_fees === "true");
    const [showAgencyNetwork,setShowAgencyNetwork] = useState(decoded.can_manage_agency_network === "true");
    
    const [showCountry,setShowCountry] = useState(decoded.can_manage_country === "true");
    const [showZone,setShowZone] = useState(decoded.can_manage_zone === "true");
    const [showSubzone,setShowSubzone] = useState(decoded.can_manage_subzone === "true");
    const [showMaison,setShowMaison] = useState(decoded.can_manage_maisons === "true");

    const [showPublisher,setShowPublisher] = useState(decoded.can_manage_publishers_vendors === "true");
    const [showAirport,setShowAirport] = useState(decoded.can_manage_airport_names === "true");
    const [showVehicle,setShowVehicle] = useState(decoded.can_manage_vehicles === "true");
    const [showPosition,setShowPosition] = useState(decoded.can_manage_positions === "true");
    
    const [showExchangeRate,setShowExchangeRate] = useState(decoded.can_manage_exchange_rate === "true");
    
    
    const [showUser,setShowUser] = useState(decoded.can_manage_users == "true");
    const [showProfile,setShowProfile] = useState(decoded.can_manage_profiles === "true");
    const [showRole,setShowRole] = useState(decoded.can_manage_roles === "true");

    const [showBudget,setShowBudget] = useState(decoded.can_access_budget_list == "true");    
    const [showReport,setShowReport] = useState(decoded.can_create_reports == "true");
    
    const refMenuPopup = useRef();

    const ToggleMenuSection = () =>{
        setShow(!show); 
    };

    const componentRef1 = useRef();
    const componentRef2 = useRef();

    const colExpMenu = (event) =>{
        if(document.getElementsByClassName("lblAccessName")[0].style.display != "none"){
            document.getElementById("MenuSidebar").style.width = "50px";
            event.stopPropagation();

            const boxes = Array.from(
                document.getElementsByClassName('lblAccessName')
              );

              boxes.forEach(box => {
                box.style.display = "none";
              });

            document.getElementById("imgArrow").style.transform = "rotate(0.5turn)";
        }else{
            document.getElementById("MenuSidebar").style.width = "20%";
            event.stopPropagation();

            const boxes = Array.from(
                document.getElementsByClassName('lblAccessName')
              );

              boxes.forEach(box => {
                box.style.display = "block";
              });

            document.getElementById("imgArrow").style.transform = "rotate(0turn)";
        }
    }

    useEffect(() => {
        if(localStorage.getItem("token") == null){   
            history.push('/login') ;
        }
        // Check session status on initial load
        if(!checkSessionStatus()){
            return;
          }
          
        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
        function handleClick(e) {
            if(componentRef1 && componentRef1.current){
                const ref1 = componentRef1.current
                const ref2 = componentRef2.current
                const ref3 = refMenuPopup.current.componentRef.current
                if(!ref1.contains(e.target) && !ref2.contains(e.target) && !ref3.contains(e.target)){
                    refMenuPopup.current.setShowUser(false); 
                    refMenuPopup.current.setshowHelp(false); 
                }
            }
        }
    }, []);

    return (<Router  history={history} basename="/">

      <div className="App">
        
        <div className="div-header" >

            <div  className="div-header-menu" style={{cursor:'pointer'}} onClick={() => ToggleMenuSection()} >
                <img src={menu} onClick={() => ToggleMenuSection()}></img>
            </div>
            <div className="div-header-info" >                
                <img src={icon}></img>
                <label className="lbl-header-info">DBT Administration Center</label>
            </div>
            <div className="div-header-help push" style={{cursor:'pointer'}} ref={componentRef1}>
                <img src={help} onClick={() => refMenuPopup.current.ToggleMenuSectionHelp()}></img>
            </div>
            <div className="div-header-account" style={{cursor:'pointer'}} ref={componentRef2}>
                <img src={account} onClick={() => refMenuPopup.current.ToggleMenuSectionUser()}></img>
            </div>
         </div>
        
          <div className="div-body">
            <div className={show ? "div-menu-sections " + (!showBudget && !showReport ? " div-menu-sections-half" : ' ') : "div-menu-sections hidden"}>
            <div className={showBudget || showReport ? "div-menu-sections_details div-menu-sections_budget" : "hidden div-menu-sections_details div-menu-sections_budget"} onClick={() => LoadSection('budget')} >
                        <img src={budgetsection}></img>
                        <label>Data & Budget Tool</label>
                </div>
                <div className={!showBudget && !showReport ? "fullwidth div-menu-sections_details div-menu-sections_admin" : "div-menu-sections_details div-menu-sections_admin" } onClick={() => LoadSection('admin')} >
                    <img src={adminsection}></img>
                    <label>Administration Center</label>
                </div>

            </div>

            <MenuPopup ref={refMenuPopup} />
            
        <div id='MenuSidebar' className="div-body-menu" style={{width: '300px'}}>
          <div className="div-menu-quickaccess" onClick={() => LoadAgencyFees('')} >              
             <div class="div-menu-details" style={{cursor:'pointer'}}>
                    <label class='lblAccessName' style={{cursor:'pointer', paddingLeft: '20px'}}>Quick Access</label>
                </div> 
                <div class="div-menu-quickaccess-img push">
                <img onClick={(e) => colExpMenu(e)} id='imgArrow' style={{height: '38px', marginRight: '10px'}} src={img_menu_arrows}></img>
                </div>               
            </div>
            <div className={showUser || showProfile || showRole ? "div-menu-li" : "div-menu-li hidden" }  onClick={() => showUser ?  LoadAgencyFees('useradministration') : showProfile ? LoadAgencyFees('profiles') : showRole ? LoadAgencyFees('roles') : LoadAgencyFees('noaccess')} >
                <div class="div-menu-img">
                <img style={{paddingRight:"5px"}} src={img_menu_administration}></img>
                </div>
                <div class="div-menu-details">
                    <label class='lblAccessName' style={{cursor:'pointer'}}>Users Administration</label>
                </div>                
            </div>
            <div className="div-menu-li hidden"  onClick={() => LoadAgencyFees('insertionpoc')} >
                <div class="div-menu-img">
                <img  src={img_menu_administration}></img>
                </div>
                <div class="div-menu-details">
                    <label class='lblAccessName' style={{cursor:'pointer'}}>Insertion POC</label>
                </div>                
            </div>
            <div className={showAgency || showAgencyNetwork ? "div-menu-li" : "div-menu-li hidden" }  onClick={() => showAgency ?  LoadAgencyFees('agencies') : LoadAgencyFees('agencynetworks')} >
                <div class="div-menu-img">
                <img style={{marginLeft:"-2px"}} src={img_menu_agency}></img>
                </div>
                <div class="div-menu-details">
                    <label class='lblAccessName' style={{cursor:'pointer'}}>Agencies</label>
                </div>                
            </div>
            <div className={showAgencyFees ? "div-menu-li" : "div-menu-li hidden" }  onClick={() => LoadAgencyFees('agencyfees')} >
                <div class="div-menu-img">
                <img style={{paddingRight:"5px"}} src={img_menu_agencyfees}></img>
                </div>
                <div class="div-menu-details">
                    <label class='lblAccessName' style={{cursor:'pointer'}}>Agency Fees</label>
                </div>                
            </div>
            <div className={showCountry || showZone || showSubzone ? "div-menu-li" : "div-menu-li hidden" } onClick={() => showZone ? LoadAgencyFees('zones') : showSubzone ? LoadAgencyFees('subzones') : showCountry ? LoadAgencyFees('countries') : LoadAgencyFees('noaccess')  } >
                <div class="div-menu-img">
                <img style={{paddingRight:"5px"}} src={img_menu_geography}></img>
                </div>
                <div class="div-menu-details">
                    <label class='lblAccessName' style={{cursor:'pointer'}}>Geography</label>
                </div>                
            </div>
            <div className={showMaison ? "div-menu-li" : "div-menu-li hidden" } onClick={() => LoadAgencyFees('maisons')} >
                <div class="div-menu-img">
                <img style={{paddingRight:"5px"}} src={img_menu_maisons}></img>
                </div>
                <div class="div-menu-details">
                    <label class='lblAccessName' style={{cursor:'pointer'}}>Maisons</label>
                </div>                
            </div>
            <div className={showPublisher || showAirport || showVehicle || showPosition ? "div-menu-li" : "div-menu-li hidden" } onClick={() => showPublisher ? LoadAgencyFees('mediareferences') : showAirport ? LoadAgencyFees('airports') : showVehicle ? LoadAgencyFees('vehicles') : showPosition ? LoadAgencyFees('positions') : LoadAgencyFees('noaccess') } >
                <div class="div-menu-img">
                <img style={{paddingRight:"5px"}} src={img_menu_mediareferences}></img>
                </div>
                <div class="div-menu-details">
                    <label class='lblAccessName' style={{cursor:'pointer'}}>Media References</label>
                </div>                
            </div>
            
            <div className={showExchangeRate ? "div-menu-li" : "div-menu-li hidden" } onClick={() => LoadAgencyFees('exchangerates')} >
                <div class="div-menu-img">
                <img style={{paddingRight:"5px"}} src={img_menu_exchangerates}></img>
                </div>
                <div class="div-menu-details">
                    <label class='lblAccessName' style={{cursor:'pointer'}}>Exchange Rates</label>
                </div>                
            </div>
            <div className="div-menu-li hidden"  onClick={() => LoadAgencyFees('trialpage')} >
                <div class="div-menu-img">
                <img src={img_menu_administration}></img>
                </div>
                <div class="div-menu-details">
                    <label>Trial Page</label>
                </div>                
            </div>

          </div>
          <div className="div-body-details">
          <div>
              <Switch>
              <Route exact path={appName+'/admin'} component={AdminHome} />
              <Route path={appName+"/admin/grid"} component={App} />
              <Route path={appName+"/admin/agencyfees"} component={AgencyFees} />
              <Route path={appName+"/admin/agencies"} component={Agencies} />
              <Route path={appName+"/admin/agencynetworks"} component={AgencyNetwork} />
              <Route path={appName+"/admin/useradministration"} component={UserAdministration} />
              <Route path={appName+"/admin/profiles"} component={Profile} />
              <Route path={appName+"/admin/roles"} component={Role} />
              <Route path={appName+"/admin/publishersvendors"} component={Publishersvendors} />
              <Route path={appName+"/admin/airports"} component={Airports} />
              <Route path={appName+"/admin/vehicles"} component={Vehicles} />
              <Route path={appName+"/admin/positions"} component={Positions} />
              <Route path={appName+"/admin/mediareferences"} component={Publishersvendors} />
              <Route path={appName+"/admin/maisons"} component={Maisons} />
              <Route path={appName+"/admin/zones"} component={Zone} />
              <Route path={appName+"/admin/subzones"} component={Subzone} />
              <Route path={appName+"/admin/countries"} component={Country} />
              <Route path={appName+"/admin/exchangerates"} component={ExchangeRates} />
              <Route path={appName+"/login/sign-up"} component={SignUp} />          
              
              <Route path={appName+"/admin/insertionpoc"} component={Insertitionpoc} />
              <Route path={appName+"/admin/planpage"} component={PlanPage} />
              <Route path={appName+"/admin/trialpage"} component={TrialPage} />


            </Switch>
          </div>
            </div>
        </div>  
        </div>
       </Router>
    );
}

export default AdminPage;
